import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import ElementUI from 'element-ui'
import VueDataTables from 'vue-data-tables'
import axios from 'axios'
import firebase from 'firebase'

import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'element-ui/lib/theme-chalk/index.css'
import 'expose-loader?$!jquery'

import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'

Vue.config.productionTip = false
axios.defaults.baseURL = 'https://mlrs-server.herokuapp.com/'

const config = {
  apiKey: 'AIzaSyCwRGxfKZI2bWFk82K5C1MGt1hJ2M8QgCQ',
  authDomain: 'mlrs-payment.firebaseapp.com',
};

firebase.initializeApp(config);

locale.use(lang)
Vue.use(ElementUI)
Vue.use(VueDataTables)

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
